import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DocumentBack } from '../../core/models/document-back.model';
import { Project } from '../../core/models/project.model';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  //private uploadedFilesSubject = new BehaviorSubject<File[]>([]);
  private uploadedFilesSubject = new Subject<File[]>();
  uploadedFiles$ = this.uploadedFilesSubject.asObservable();

  private extractedDocuments = new Subject<Project>();
  extractedDocuments$ = this.extractedDocuments.asObservable();

  private refactorResponseSubject = new BehaviorSubject<any>(null);
  refactorResponse$ = this.refactorResponseSubject.asObservable();

  private testUnitResponseSubject = new BehaviorSubject<any>(null);
  testUnitResponse$ = this.testUnitResponseSubject.asObservable();

 /*  addFile(file: File) {
    const currentFiles = this.uploadedFilesSubject.value;
    this.uploadedFilesSubject.next([...currentFiles, file]);
  } */

  setExtractedDocuments(project: Project) {
    this.extractedDocuments.next(project);
  }

  //replace the previous file
  setFile(files: File[]) {
    this.uploadedFilesSubject.next(files);
  }

  clearFile() {
    this.uploadedFilesSubject = new Subject<File[]>();
  }

  // Method for storing the refactoring response
  setRefactorResponse(response: any) {
    this.refactorResponseSubject.next(response);
  }

  // Method for storing the unit-test response
  setUnitTestResponse(response: any) {
    this.testUnitResponseSubject.next(response);
  }
}